import React from "react";
import Title from "../../../components/Title";
import util1 from "../../../assets/tokenomic-util1.svg";
import util2 from "../../../assets/tokenomic-util2.png";
import util4 from "../../../assets/tokenomic-util3.png";
import util3 from "../../../assets/eco-utils1.png";
import tokenomic from "../../../assets/tokenomic.png";
const Tokenomics = () => {
  return (
    <div className="relative" id="tokenomics">
      <div className="absolute h-[50%] bg-primary w-[20px] top-0 left-0 md:block hidden"></div>
      <div className="absolute h-[50%] bg-primary w-[20px] bottom-0 right-0 md:block hidden"></div>
      <img
        src={util2}
        className="absolute right-4 w-28 md:block hidden"
        alt=""
      />
      <img
        src={util3}
        className="absolute right-40 w-12 md:block hidden"
        alt=""
      />
      <img
        src={util4}
        alt=""
        className="absolute left-40 w-20 md:w-36 bottom-0"
      />
      <div className="container py-20">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Title text="Tokenomics" image={util1} />
          <h3 className="text-xl md:text-2xl font-serif font-medium mt-10 md:mt-0">
            <span className="text-gray"> Total Supply:</span> 200,000,000,000
          </h3>
        </div>
        <img src={tokenomic} className="max-w-[800px] mx-auto w-full" alt="" />
      </div>
    </div>
  );
};

export default Tokenomics;
